// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-div[data-v-d780014c] {\n  height: 25px;\n  text-align: right;\n  padding-right: 1px;\n  font-style: italic;\n}\n", ""]);
// Exports
module.exports = exports;
